import React, { useMemo } from 'react';
import { LiveSignalStats } from '../../../hooks/v2/useLessonControlData';

interface LiveHealthStripProps {
  liveSignalStats: LiveSignalStats;
}

export const LiveHealthStrip: React.FC<LiveHealthStripProps> = ({ liveSignalStats }) => {
  const needsAttention = (
    Number(liveSignalStats.step_signal_pending || 0) > 0
    || Number(liveSignalStats.missing_reasoning || 0) > 0
    || Number(liveSignalStats.missing_confidence || 0) > 0
  );

  const attentionSummary = useMemo(() => {
    const segments: string[] = [];
    if (Number(liveSignalStats.step_signal_pending || 0) > 0) {
      segments.push(`${liveSignalStats.step_signal_pending} pending`);
    }
    if (Number(liveSignalStats.missing_reasoning || 0) > 0) {
      segments.push(`${liveSignalStats.missing_reasoning} missing reasoning`);
    }
    if (Number(liveSignalStats.missing_confidence || 0) > 0) {
      segments.push(`${liveSignalStats.missing_confidence} missing confidence`);
    }
    return segments.length > 0 ? segments.join(' • ') : 'No action needed';
  }, [liveSignalStats]);

  return (
    <div className="mt-3 flex flex-wrap items-center gap-2 rounded border border-gray-200 bg-white px-3 py-2 text-xs text-gray-700">
      <span className="rounded-full bg-indigo-50 px-2 py-1 text-indigo-700">
        Submitted: {liveSignalStats.step_signal_submitted}/{liveSignalStats.total_students}
      </span>
      <span className={`rounded-full px-2 py-1 ${
        liveSignalStats.step_signal_pending > 0 ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700'
      }`}>
        Pending: {liveSignalStats.step_signal_pending}
      </span>
      <span
        className={`rounded-full px-2 py-1 ${needsAttention ? 'bg-rose-100 text-rose-700' : 'bg-emerald-100 text-emerald-700'}`}
        title={attentionSummary}
      >
        Act now: {needsAttention ? 'Yes' : 'No'}
      </span>
    </div>
  );
};
